import React from 'react'
import CustomCarousel from "./Carousel"

const Home = () => {
  return (
<div >
  <CustomCarousel/>

  <hr />
          <hr />


        <div className="justify-content-center row">

         <u>
         <h4 className='header'>About us</h4>
         </u>

         
        <div className="right-content">
            <p>We deal with water treatment equipments and chemicals. We stock, supply,install, commision and service all equipments related to water treatment for industries, hospitals,phamaceuticals,school,hotel,residentials,commertials etc.</p>
                        
          </div> 
          <u>
          <h2>Product</h2>
          </u> 

        
          {/* <input
            type="text"
            className="form-control shadow-sm p-2 text-cyan"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
        /> */}


<div className="row">

  {[  
    { src: "images/jalistep/pic23 (59).jpg", title: "Activated Carbon" },
    { src: "images/jalistep/pic2.jpg", title: "Ro plant industrial" },
    { src: "images/jalistep/pic9.jpg", title: "Filters" },
    { src: "images/jalistep/pic4.jpg", title: "Meters" },
    { src: "images/jalistep/pic23 (50).png", title: "Pumps" },
    { src: "images/jalistep/pic14.jpg", title: "RO's" },
    { src: "images/jalistep/pic7.jpg", title: "Vessels" },
    { src: "images/jalistep/pic23 (94).png", title: "Membranes" }
  ].map((product, index) => (
    <div key={index} className="col-md-3 mb-4 d-flex justify-content-center">
      <div className="card product-card shadow">
        <img src={product.src} alt={product.title} className="product_img" />
        <div className="card-body d-flex flex-column justify-content-end">
          <h5 className="mt-2 text-cyan">{product.title}</h5>
        </div>
      </div>
    </div>
  ))}

</div>


       
 </div>

 
 </div>

    
  )
}

export default Home;
